export default "assets/images/icons/logement-89ec15ef.svg";